<Price v-if="minProduct" :display="display" :product="minProduct" :fill="fill"></Price>